import * as React from "react";
const SvgPlay = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 15L7 15L14 8L7 1L5 1L5 15Z", fill: "currentColor" }));
export default SvgPlay;
